
import { MdOutlineInventory,  } from "react-icons/md";
import routes from "./routes";
import { LuUser } from "react-icons/lu";
import { RiPagesLine } from "react-icons/ri";
import { RiFileEditLine } from "react-icons/ri";
import { RiShieldUserLine } from "react-icons/ri";
import { RiHistoryLine } from "react-icons/ri";

const menus = [
  {
    icon: <MdOutlineInventory />,
    label: "Admin",
    requiredPermissions: ["users.view", "roles.view"],
    type: "group",
    children: [
      {
        key: routes.USERS.path,
        label: "Users",
        icon: <LuUser />,
        requiredPermissions: ["users.view"],
      },
      {
        key: routes.ROLES.path,
        label: "Roles",
        icon: <RiShieldUserLine />,
        requiredPermissions: ["roles.view"],
      },
      {
        key: routes.ACTIVITY_LOGS.path,
        label: "Activity Logs",
        icon: <RiHistoryLine />,
        requiredPermissions: ["activity-logs.view"],
      },
    ],
  },
  {
    icon: <MdOutlineInventory />,
    label: "CMS",
    requiredPermissions: ["cms.view", "blogs.view"],
    type: "group",
    children: [
      {
        key: routes.CMSPAGE.path,
        label: "Pages",
        requiredPermissions: ["cms.view"],
        icon: <RiPagesLine />,
      },
      {
        key: routes.BLOGS.path,
        label: "Blogs",
        requiredPermissions: ["blogs.view"],
        icon: <RiFileEditLine />,
      },
    ],
  },
];

export default menus;
